import React, { useState, useEffect } from 'react';
import { Table, StatusTip, ConfigProvider } from 'tea-component';
import { useIntl, history } from 'umi';
import FirstColContent from './FirstColContent';
import MetricColContent from './MetricColContent';
import SpecialColContent from './SpecialColContent';
import CheckboxContent from '@/pages/intelligence/pages/GlobalView/components/TopMarketGenreCore/components/Table/CheckboxContent';
import { IMetricList } from '@/pages/intelligence/pages/GenreProfile/typings';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';
import TableImg from '@/pages/intelligence/components/TableComponents/components/TableImg';
import { TOP_GAMES_DISPLAY_LIMIT } from '../../constants';

const { LoadingTip } = StatusTip;

const { scrollable, autotip, expandable, pageable } = Table.addons;

export default function InsideTable(props) {
  const {
    records,
    expandedTableCol = [],
    keyMap,
    entityType,
    onGameItemClick
  } = props;
  // 表格数据

  const { formatMessage } = useIntl(); // 中英切换方法
  const defaultPage = 5;
  const [tableLoading, setTableLoading] = useState(true);
  const [total, setTotal] = useState(0);

  const goGameDetail = (gameId: string) => {
    if (gameId) history.push(getDetailGameOverviewPath(gameId, entityType));
  }

  const getAllColumns = () => {
    return expandedTableCol?.map((colConfig) => {
      const {
        key,
        metric: metricName,
        positionType,
        width,
        align = 'right',
        isLabelHide,
        isRightBorderHide
      } = colConfig;

      switch (positionType) {
        case 'first':
          return {
            key: key,
            fixed: 'left',
            width,
            align,
            render: (cvm: any) =>
              <FirstColContent
                context={cvm}
                config={colConfig}
                pageIndex={''}
                pageSize={''}
                keyMap={keyMap}
                getDateColFormat={() => { }}
                onGameItemClick={() => { }}
              />
          }
        case 'metric':
          return {
            key: metricName,
            width,
            align,
            render: (cvm: any) => {
              const metricList = cvm[keyMap.metricList] || [];
              const find = metricList?.find((item: IMetricList) => item[keyMap.metricName] === metricName) || {};
              if (!find) return;
              return (
                <MetricColContent
                  config={colConfig}
                  metricName={metricName}
                  keyMap={keyMap}
                  context={find}
                  isRightBorderHide={isRightBorderHide}
                  ratioHideCol={[]}
                  textBubble={''}
                />
              )
            },
          }
        case 'special':
          return {
            key: key,
            width,
            align,
            render: (cvm: any) =>
              <SpecialColContent
                context={cvm}
                config={colConfig}
                isLabelHide={isLabelHide}
                onGameItemClick={onGameItemClick}
              />
          }
        case 'checkbox':
          return {
            key: 'select',
            width,
            fixed: 'left',
            render: (cvm: any) => (
              <CheckboxContent
                isLabelHide={isLabelHide}
                selected={[]}
                context={cvm}
                uniqueKey={'id'}
              />
            ),
          }
        case 'topRevenue':
          return {
            key: 'topRevenue',
            width,
            align,
            render: (cvm) => {
              const topGameList = Array.isArray(cvm?.topGames)
                ? cvm.topGames.slice(0, TOP_GAMES_DISPLAY_LIMIT)
                : [];
              return <TableImg cvm={topGameList}
                getClick={(gameId) => goGameDetail(gameId.app_id)}
                entityType={entityType}
              />
            }
          }
        default:
          return {}
      }
    })
  };

  useEffect(() => {
    setTableLoading(true);
    setTotal(records?.length);
    setTableLoading(false);
  }, [records?.length])

  // console.log(records)

  return (
    <div>
      <ConfigProvider locale="en">
        {tableLoading ? (
          <div
            // className="streaming-metric-loading"
            style={{
              background: '#f7f7f7',
              height: 120,
              textAlign: 'center',
              paddingTop: 55,
            }}
          >
            <LoadingTip />
          </div>
        ) : (
          <div
            className={"dbi-inside-table"}
          >
            <Table
              recordKey={() => 'name'}
              hideHeader={true}
              records={records}
              bordered={false}
              columns={getAllColumns()}
              addons={[
                pageable({
                  stateTextVisible: true,
                  // recordCount: tableLoading ? 0 : total,
                  pageSizeVisible: total > defaultPage,
                  pageIndexVisible: total > defaultPage,
                  jumpVisible: total > defaultPage,
                  endJumpVisible: total > defaultPage,
                  stateText: formatMessage(
                    { id: 'dbi_pagination_total' },
                    { total: total ?? 0 },
                  ),
                  pageSizeOptions: [defaultPage, 10, 15],
                }),
                scrollable({ minHeight: 10 }),
                autotip({
                  emptyText: 'No data under current selections',
                }),
                expandable({
                  // expandedKeys,
                  // gapCell: 1,
                  shouldRecordExpandable: (record) => {
                    return false;
                  },
                }),
              ]}
            />
          </div>
        )}
      </ConfigProvider>
    </div>
  );
}
